module.exports = __webpack_public_path__ + "img/coffin.4daeb8b5.svg";